var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 17,
    x: 0,
    y: 0,
    viewBox: "0 0 466.205 466.205",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,-1.2246467991473532e-16,1.2246467991473532e-16,-1,466.20486450195307,466.2052600569151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m416.193 170.894-.158-.158-162.986-163.2a25.37 25.37 0 0 0-4.267-3.413l-4.693-2.56-3.2-1.067h-2.347a30.095 30.095 0 0 0-10.88 0h-4.693l-3.627 1.92a25.827 25.827 0 0 0-5.547 4.053L50.169 170.736c-10.957 10.87-11.028 28.565-.158 39.522l.158.158c11.045 10.538 28.421 10.538 39.467 0l97.493-97.28c4.206-4.124 10.96-4.058 15.084.149a10.662 10.662 0 0 1 3.049 7.318v317.653c-.001 15.435 12.51 27.948 27.945 27.949 15.435.001 27.947-12.51 27.949-27.945V120.603c.083-5.89 4.925-10.599 10.815-10.516 2.74.039 5.361 1.13 7.318 3.049l97.067 97.28c11.073 10.674 28.607 10.674 39.68 0 10.957-10.87 11.028-28.565.157-39.522z",
    fill: "red",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.750953c62eb7a777971a3bbd3d206bbf.svg";
export { ForwardRef as ReactComponent };